import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { List, Map } from "immutable";

import resourceTypes from "MODULES/shared/types/resourceTypes";
import getNotesConnectorKey from "MODULES/shared/components/Notes/getNoteBodyFieldName";
import { ID } from "APP_ROOT/constants";
import { ConfirmAction } from "MODULES/shared/components";
import * as actions from "MODULES/shared/actions/notes";
import * as actionTypes from "MODULES/shared/actionTypes";
import resourceToStateKey from "./resourceToStateKey";
import Note from "./Note";
import Header from "./Header";
import HeaderImportant from "./HeaderImportant";
import HeaderMinor from "./HeaderMinor";
import HeaderTrace from "./HeaderTrace";
import EditNote from "./EditNote/EditNote";
import ViewNote from "./ViewNote/ViewNote";
import ConfirmDelete from "../ConfirmDelete/ConfirmDelete";

export class Notes extends React.Component {
  constructor() {
    super();
    this.handleEditNote = this.handleEditNote.bind(this);
    this.handleViewNote = this.handleViewNote.bind(this);
    this.handleDeleteNote = this.handleDeleteNote.bind(this);
    this.toggleAction = this.toggleAction.bind(this);
  }

  state = {
    selectedNote: Map(),
    editNoteModalOpen: false,
    viewNoteModalOpen: false,
    deleteOpen: false
  };

  componentDidMount() {
    const { dispatch, resource, resourceType, notesType } = this.props;

    dispatch(actions.getNotes(resource.get(ID), resourceType, notesType));
  }

  deleteNote = note => {
    const { dispatch, resource, resourceType, notesType } = this.props;

    dispatch(
      actions.removeNote(resource.get(ID), resourceType, note, notesType)
    );
  };

  handleEditNote(note) {
    this.setState({ selectedNote: note });
    this.openEditNotesModal();
  }

  handleViewNote(note) {
    this.setState({ selectedNote: note });
    this.openViewNotesModal();
  }

  handleDeleteNote(note) {
    this.setState({ selectedNote: note });
    this.openDeleteModal();
  }

  toggleAction(note, key) {
    this.setState({ [key]: !this.state[key], selectedNote: note });
  }

  openEditNotesModal = () => this.setState({ editNoteModalOpen: true });

  openViewNotesModal = () => this.setState({ viewNoteModalOpen: true });

  openDeleteModal = () => this.setState({ deleteOpen: true });

  closeEditNotesModal = () => this.setState({ editNoteModalOpen: false });

  closeViewNotesModal = () => this.setState({ viewNoteModalOpen: false });

  closeDeleteModal = () => this.setState({ deleteOpen: false });

  render() {
    const {
      additionalActions,
      filter,
      resource,
      resourceType,
      isLoading,
      notesType
    } = this.props;
    const allNotes = this.props.notes;
    let notes = allNotes.filter(n => !n.get("trace"));

    if (filter) notes = notes.filter(n => filter(n));

    const {
      selectedNote,
      editNoteModalOpen,
      viewNoteModalOpen,
      deleteOpen
    } = this.state;
    const importantNote = notes.find(n => n.get("important") === true);
    const minorNote = notes.find(n => n.get("minor") === true);

    const traceNotes = allNotes.filter(n => n.get("trace"));

    if (importantNote !== undefined) {
      notes = notes.splice(notes.indexOf(importantNote), 1);
    }
    if (minorNote !== undefined) {
      notes = notes.splice(notes.indexOf(minorNote), 1);
    }

    return (
      <div>
        {resourceType === resourceTypes.inventory && [
          <HeaderImportant
            {...this.props}
            important={importantNote !== undefined}
          />,
          importantNote && (
            <Note
              additionalActions={additionalActions}
              key={importantNote.get(ID)}
              note={importantNote}
              resourceID={resource.get(ID)}
              onEditNote={this.handleEditNote}
              onViewNote={this.handleViewNote}
              onDeleteNote={this.handleDeleteNote}
              toggleAction={this.toggleAction}
              notesType={notesType}
            />
          )
        ]}

        {resourceType === resourceTypes.receivingRecord && [
          <HeaderMinor {...this.props} minor={minorNote !== undefined} />,
          minorNote && (
            <Note
              additionalActions={additionalActions}
              key={minorNote.get(ID)}
              note={minorNote}
              resourceID={resource.get(ID)}
              onEditNote={this.handleEditNote}
              onViewNote={this.handleViewNote}
              onDeleteNote={this.handleDeleteNote}
              notesType={notesType}
            />
          )
        ]}

        {this.props.trace && <HeaderTrace {...this.props} />}

        {resourceType !== resourceTypes.receivingRecord &&
          !this.props.trace && <Header {...this.props} />}

        {isLoading && (
          <div
            className="panel panel-default panel-note animate-row"
            style={{ height: "80px" }}
          />
        )}

        {!isLoading &&
          notes.size === 0 && (
            <div style={{ height: "80px", visibility: "hidden" }} />
          )}

        {resourceType !== resourceTypes.receivingRecord &&
          !this.props.trace &&
          notes.map(note => (
            <Note
              additionalActions={additionalActions}
              key={note.get(ID)}
              note={note}
              resourceID={resource.get(ID)}
              onViewNote={this.handleViewNote}
              onEditNote={this.handleEditNote}
              onDeleteNote={this.handleDeleteNote}
              notesType={notesType}
              toggleAction={this.toggleAction}
            />
          ))}

        {this.props.trace &&
          traceNotes.map(note => (
            <Note
              additionalActions={additionalActions}
              key={note.get(ID)}
              note={note}
              resourceID={resource.get(ID)}
              onViewNote={this.handleViewNote}
              onEditNote={this.handleEditNote}
              onDeleteNote={this.handleDeleteNote}
              notesType={notesType}
            />
          ))}
        <ViewNote
          note={selectedNote}
          resourceID={resource.get(ID)}
          resourceType={resourceType}
          open={viewNoteModalOpen}
          close={this.closeViewNotesModal}
          notesType={notesType}
        />
        <EditNote
          note={selectedNote}
          resourceID={resource.get(ID)}
          resourceType={resourceType}
          open={editNoteModalOpen}
          close={this.closeEditNotesModal}
          notesType={notesType}
        />
        <ConfirmDelete
          onConfirm={() => this.deleteNote(selectedNote)}
          close={this.closeDeleteModal}
          open={deleteOpen}
        >
          <strong>Heads up!</strong> Are you sure you want to delete this?
        </ConfirmDelete>

        {additionalActions &&
          additionalActions.map(action => {
            const open = this.state[`${action.key}`];
            return (
              <ConfirmAction
                open={open}
                close={() => this.setState({ [action.key]: !open })}
                onConfirm={() =>
                  action.onConfirm(this.props.updateNote)(selectedNote)}
              />
            );
          })}
      </div>
    );
  }
}

Notes.propTypes = {
  additionalActions: PropTypes.arrayOf(PropTypes.shape({})),
  dispatch: PropTypes.func.isRequired,
  filter: PropTypes.func,
  trace: PropTypes.bool,
  resourceType: PropTypes.string.isRequired,
  notesType: PropTypes.string,
  resource: PropTypes.instanceOf(Map).isRequired,
  notes: PropTypes.instanceOf(List),
  isLoading: PropTypes.bool.isRequired
};

Notes.defaultProps = {
  notesType: ""
};

export default connect(
  (state, ownProps) => ({
    notes: state[resourceToStateKey(ownProps.resourceType)].get(
      getNotesConnectorKey(ownProps.notesType, "notes"),
      []
    ),
    isLoading: state[resourceToStateKey(ownProps.resourceType)].get(
      "notesLoading"
    ),
    id: ownProps.resource.get(ID)
  }),
  (dispatch, ownProps) => ({
    updateNote: data => {
      dispatch({
        type: actions.actionFactory(
          actionTypes.UPDATE_NOTE,
          ownProps.resourceType
        ),
        note: data,
        notesType: ownProps.resourceType
      });
    },
    dispatch
  })
)(Notes);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/Notes.jsx